import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface SearchSuggestion {
  type: 'theme' | 'inventory' | 'plate' | 'dish';
  name: string;
  id: string;
}

interface SearchContextType {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  searchAnchorEl: HTMLElement | null;
  setSearchAnchorEl: (el: HTMLElement | null) => void;
  showSuggestions: boolean;
  setShowSuggestions: (show: boolean) => void;
  searchSuggestions: SearchSuggestion[];
  setSearchSuggestions: (suggestions: SearchSuggestion[]) => void;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const SearchProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchAnchorEl, setSearchAnchorEl] = useState<HTMLElement | null>(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [searchSuggestions, setSearchSuggestions] = useState<SearchSuggestion[]>([]);

  return (
    <SearchContext.Provider
      value={{
        searchQuery,
        setSearchQuery,
        searchAnchorEl,
        setSearchAnchorEl,
        showSuggestions,
        setShowSuggestions,
        searchSuggestions,
        setSearchSuggestions,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
};

